import { render } from "./VehicleReportCanceledTable.vue?vue&type=template&id=5c1536ec&ts=true"
import script from "./VehicleReportCanceledTable.vue?vue&type=script&lang=ts"
export * from "./VehicleReportCanceledTable.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./VehicleReportCanceledTable.vue?vue&type=style&index=0&id=5c1536ec&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSeparator,QTable,QTr,QTh,QTd});
